export * from './OnlineOrderingNotConfigured.ui';
